// ── Step 6 Writeback Diff Notice — Pure DOM writes, no state or API ───────

function createNoticeElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createDiffColumn(label, text, tone) {
  const column = createNoticeElement('div', 'revision-writeback-notice__column');
  column.append(
    createNoticeElement('div', 'revision-writeback-notice__label', label),
    createNoticeElement('div', `revision-writeback-notice__text revision-writeback-notice__text--${tone}`, text),
  );
  return column;
}

function createDiffCard(item = {}) {
  const card = createNoticeElement('div', 'revision-writeback-notice__card');
  const grid = createNoticeElement('div', 'revision-writeback-notice__grid');
  grid.append(
    createDiffColumn('修改前', item.before ?? '', 'before'),
    createDiffColumn('修改后', item.after ?? '', 'after'),
  );
  card.append(createNoticeElement('div', 'revision-writeback-notice__field', item.label ?? ''), grid);
  return card;
}

/** Replaces the visible Step 03 writeback notice with the supplied diff items. */
export function renderRevisionDiffNoticeInto(items = [], {
  existing = null,
  reviewStrip = null,
  generationRoot = null,
} = {}) {
  existing?.remove();
  if (!Array.isArray(items) || !items.length) return null;

  const notice = createNoticeElement('div', 'revision-writeback-notice');
  notice.id = 'step3-revision-diff-notice';
  const head = createNoticeElement('div', 'revision-writeback-notice__head');
  head.append(
    createNoticeElement('strong', 'revision-writeback-notice__title', '已应用改稿'),
    createNoticeElement('span', 'panel-subtitle revision-writeback-notice__count', `变更 ${items.length} 项`),
  );
  const list = createNoticeElement('div', 'revision-writeback-notice__list');
  list.append(...items.map(createDiffCard));
  notice.append(head, list);

  if (reviewStrip) {
    reviewStrip.insertAdjacentElement('afterend', notice);
  } else {
    generationRoot?.prepend(notice);
  }
  return notice;
}
